import { useEffect, useMemo, useState } from "react";
import styles from "./Tabs.module.css";
import * as toast from "../../utils/makeToast";

interface TabsProps {
  tabNames: string[];
  onClickTab: (name?: string) => void;
  extraClasses?: string;
  disabledTab?: string;
  errorMessage?: string;
}
const Tabs: React.FC<TabsProps> = ({
  tabNames,
  onClickTab,
  extraClasses,
  disabledTab,
  errorMessage,
}) => {
  const { errorToast } = toast;
  const [activeTab, setActiveTab] = useState("");
  const tabs = useMemo(() => tabNames || [], [tabNames]);

  const handleClickTab = (tab: string) => {
    if (!tab) return;
    if (tab === disabledTab) return errorToast(errorMessage || "Coming Soon!");
    setActiveTab(tab);
    onClickTab(tab);
  };

  useEffect(() => {
    if (tabs) {
      setActiveTab(tabs[0]);
    }
  }, [tabs.length]);
  return (
    <div className={`${styles.tabsWrapper}`}>
      {!tabs.length ? (
        <span>Loading...</span>
      ) : (
        tabs.map((name) => (
          <span
            key={name}
            className={`${styles.tabItem} ${
              styles[activeTab === name ? "activeTab" : "inactiveTab"]
            } text-nowrap  ${extraClasses}`}
            onClick={() => handleClickTab(name)}
          >
            {name}
          </span>
        ))
      )}
    </div>
  );
};

export default Tabs;
